// src/auth/useLogoutFlow.js
// Hook compartido para el flow de cerrar sesión con splash de transición.
//
// Uso:
//   const { showLogoutSplash, startLogout, handleLogoutComplete } = useLogoutFlow();
//   if (showLogoutSplash) return <SplashScreen type="logout" onComplete={handleLogoutComplete} />;
//   <button onClick={startLogout}>Cerrar sesión</button>
//
// FIX BUG 2: signOut() se difiere hasta DESPUÉS del navigate('/') para
// que el splash respete sus 4 segundos completos sin importar la
// velocidad de signOut. Si lo llamáramos en startLogout, AuthContext
// setearía user=null inmediatamente; ProtectedRoute detectaría eso y
// haría Navigate('/login'), desmontando la ruta protegida (Paywall,
// Sidebar, etc.) y con ella el portal del splash. El splash duraría
// ~50ms en vez de 4000ms.
//
// Con el flow nuevo: startLogout solo monta el splash; user permanece
// autenticado los 4s; el splash llama handleLogoutComplete a los 3600ms;
// ahí navegamos a '/' (ruta pública, sin guard) y SOLO DESPUÉS hacemos
// signOut() en background. Para ese momento ya no estamos en una ruta
// protegida, así que user=null no dispara redirect alguno.
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { clearSessionExpiredFlag } from './authHelpers';

export function useLogoutFlow() {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const [showLogoutSplash, setShowLogoutSplash] = useState(false);

  const startLogout = () => {
    // Solo monta el splash. signOut() se difiere a handleLogoutComplete.
    setShowLogoutSplash(true);
  };

  const handleLogoutComplete = () => {
    // Llamado por SplashScreen a los (effectiveDuration - 400)ms.
    // 1. Limpiar flag de expiración para que el banner no aparezca.
    clearSessionExpiredFlag();
    // 2. Salir de la ruta protegida ANTES de signOut. Una vez en '/'
    //    (landing pública), user=null no dispara redirect.
    navigate('/', { replace: true });
    // 3. signOut en background — no esperamos.
    signOut().catch((err) => console.warn('[logout] signOut error:', err));
  };

  return {
    showLogoutSplash,
    startLogout,
    handleLogoutComplete,
  };
}
